import { useCallback, useEffect, useRef } from 'react';

type AnyFn<A extends any[], R> = (...args: A) => R;

export const useStableCallback = <A extends any[], R>(
  fn: AnyFn<A, R>,
): AnyFn<A, R> => {
  const fnRef = useRef<AnyFn<A, R>>(fn);

  useEffect(() => {
    fnRef.current = fn;
  });

  return useCallback((...args: A): R => fnRef.current(...args), []);
};
